export enum CashMovementType {
  INITIAL = 'initial',
  ADDITION = 'addition',
  WITHDRAWAL = 'withdrawal',
  CLOSING = 'closing'
}

export interface CashMovement {
  id: string;
  type: CashMovementType;
  amount: number;
  date: number;
  notes: string;
  userId: string | null;
  createdBy?: string;
  parentUserId?: string;
  ownerId?: string;
  registerId?: string;
}

export interface CashRegisterState {
  id: string;
  isOpen: boolean;
  openDate: number;
  closeDate?: number;
  initialAmount: number;
  currentAmount: number;
  userId: string | null;
  createdBy?: string;
  parentUserId?: string;
  ownerId?: string;
}

export interface CashierSummary {
  totalSales: number;
  cashSales: number;
  cardSales: number;
  orderCount: number;
}
